function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import AssetPartComponent from "components/core/one-pager/asset-part/asset-part-component";
import TextPartComponent from "/components/core/one-pager/desktop-content/text-part/text-part-component";
import { withAbTests } from "/contexts/ab-tests-context";
import { StyledDesktopContentComponent } from "./desktop-content-component.scss";
class DesktopContentComponent extends PureComponent {
    render() {
        const { assetPart, textPart, signupForm = {}, collaborationWith, popupVideo, abTests } = this.props;
        signupForm.focusOnLoad = true;
        return /*#__PURE__*/ _jsxs(StyledDesktopContentComponent, {
            className: "desktop-content-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "asset-part-wrapper",
                    children: /*#__PURE__*/ _jsx(AssetPartComponent, {
                        assetType: assetPart.type,
                        assetProps: assetPart.props
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-part-wrapper",
                    children: /*#__PURE__*/ _jsx(TextPartComponent, _object_spread_props(_object_spread({}, textPart), {
                        signupForm: signupForm,
                        collaborationWith: collaborationWith,
                        popupVideo: popupVideo
                    }))
                })
            ]
        });
    }
}
export default withAbTests(DesktopContentComponent);
